import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '@environment';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { FieldValue } from '@form-field-module/common/models/field-value.model';

@Injectable({
    providedIn: 'root',
})
export class FieldsService {
    currentFields: Field[] = [];
    fieldsUpdated = new Subject<void>();
    editedFields: Field[] = [];
    ticketCreatorId = '';
    initialFieldsValues = [];
    isGotFields = false;

    constructor(private httpClient: HttpClient) {}

    emitFieldsUpdated() {
        this.fieldsUpdated.next();
    }

    getAll(ticketId: number): Observable<Field[]> {
        return this.httpClient.get<Field[]>(environment.apiInboxUrl + 'tickets/' + ticketId + '/fields/');
    }

    hasUnsavedChanges(): boolean {
        const currentValues = this.editedFields.map((f) => f.value);
        return JSON.stringify(currentValues) !== JSON.stringify(this.initialFieldsValues);
    }

    update(ticketId: number, fields: FieldValue[]): Observable<void> {
        return this.httpClient.patch<void>(environment.apiInboxUrl + 'tickets/' + ticketId + '/fields/', fields);
    }
}
